import type { BoggleChallengeBoardDistributionDefinition } from '~/boggle/config/boardDistributions/boardDistributionDefinition'
import type { BoggleChallengeBoardDistributionFamilyId } from '~/boggle/config/boardDistributions/types'
import type { BoggleResolvedChallengeBoardDistribution } from '~/boggle/config/challenges/modTypes'
import { resolveCommonConsonantsOnlyBoardDistribution } from '~/boggle/config/boardDistributions/definitions/commonConsonantsOnly'
import { resolveMoreCommonLetterBoardDistribution } from '~/boggle/config/boardDistributions/definitions/moreCommonLetter'
import { resolveNoCommonConsonantsBoardDistribution } from '~/boggle/config/boardDistributions/definitions/noCommonConsonants'
import { resolveOopsAllEsBoardDistribution } from '~/boggle/config/boardDistributions/definitions/oopsAllEs'
import { resolveVowelParingBoardDistribution } from '~/boggle/config/boardDistributions/definitions/vowelParing'
import { resolveStandardBoardDistribution } from '~/boggle/config/boardDistributions/definitions/standard'

export type BoggleBoardDistributionCompatibilityMode = 'never' | 'selected-mods'

export type BoggleBoardDistributionResolverEntry = {
  compatibilityMode: BoggleBoardDistributionCompatibilityMode
  resolve: (
    family: BoggleChallengeBoardDistributionDefinition,
    rngState: number,
  ) => {
    mod: BoggleResolvedChallengeBoardDistribution
    rngState: number
  }
}

export const BOARD_DISTRIBUTION_RESOLVERS = {
  standard: {
    compatibilityMode: 'never',
    resolve: resolveStandardBoardDistribution,
  },
  'common-consonants-only': {
    compatibilityMode: 'never',
    resolve: resolveCommonConsonantsOnlyBoardDistribution,
  },
  'more-common-letter': {
    compatibilityMode: 'never',
    resolve: resolveMoreCommonLetterBoardDistribution,
  },
  'no-common-consonants': {
    compatibilityMode: 'never',
    resolve: resolveNoCommonConsonantsBoardDistribution,
  },
  'oops-all-es': {
    // Only this modular board family is still checked against selected mods here;
    // the others resolve directly.
    compatibilityMode: 'selected-mods',
    resolve: resolveOopsAllEsBoardDistribution,
  },
  'vowel-paring': {
    compatibilityMode: 'never',
    resolve: resolveVowelParingBoardDistribution,
  },
} satisfies Record<
  BoggleChallengeBoardDistributionFamilyId,
  BoggleBoardDistributionResolverEntry
>
